export const CHROME_WEB_STORE_RECORDER_URL =
  'https://chromewebstore.google.com/detail/testsigma-recorder/epmomlhdjfgdobefcpocockpjihaabdp';
